import { useToast } from "@chakra-ui/react";
import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useSlugParam } from "@/common/hooks/useParam";
import { EnvironmentUrl } from "@reflag/shared/urls";

export default function RequireEnvironment({
  children,
}: {
  children: ReactNode;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const { envId } = useSlugParam("env");
  const { app, env } = useEnvironment();

  useEffect(() => {
    // If the requested environment id is not the same as the current environment id,
    // redirect to the current environment
    if (envId !== env.id) {
      const toastId = "environment-not-found-redirect";

      if (!toast.isActive(toastId)) {
        toast({
          id: toastId,
          position: "top",
          variant: "subtle",
          status: "warning",
          description: `The environment you wanted to access was not available. Redirected you to: ${app.name} (${env.name})`,
          duration: 5000,
        });
      }

      navigate(EnvironmentUrl(env), { replace: true });
    }
  }, [env, envId, toast, navigate, location, app]);

  return <>{children}</>;
}
